import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { AnimatePresence, motion } from 'framer-motion';

import { Icon } from '@/utils/icons';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant' as ScrollBehavior,
    });
  }, [pathname]);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          onClick={scrollToTop}
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          whileHover={{
            scale: 1.12,
            y: -2,
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
          }}
          whileTap={{ scale: 0.92 }}
          className="fixed bottom-4 left-4 z-40 flex h-12 w-12 items-center justify-center rounded-full border border-neutral-200/50 bg-white/80 text-neutral-800 shadow-[0_8px_30px_rgba(0,0,0,0.08)] backdrop-blur-md transition-all duration-300 focus:ring-4 focus:ring-neutral-200 focus:outline-none dark:border-neutral-800/50 dark:bg-neutral-900/80 dark:text-neutral-200 dark:focus:ring-neutral-800"
          aria-label="Scroll to top">
          <Icon name="ChevronUp" size={24} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default React.memo(ScrollToTop);
